import {
  IndexFeaturesComponentImageDiv,
  IndexFeaturesComponentItem,
  IndexFeaturesComponentMainDiv,
} from "../../styles/indexcomponentsstyles/indexfeaturescomponentstyles";
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan";
import { ReactComponent as Staricon } from "./assets/star-of-life-solid-full.svg";
const IndexFeaturesComponent = () => {
  return (
    <IndexFeaturesComponentMainDiv>
      <div>
        <div className="feature-header">
          <div className="feature-header-container">
            <div>
              <div>
                <HeaderSpan text="AI-Driven Features" />
              </div>
            </div>
            <div>
              <div className="feature-header-text-container">
                <h2>Everything You Need to Unlock AI Power</h2>
              </div>
            </div>
          </div>
          <div>
            <div className="feature-header-text-container">
              <p>
                Designed for you, our features put the power of AI at your fingertips—helping you work smarter, save time, and unlock new possibilities with ease.              </p>
            </div>
          </div>
        </div>
        <div className="feature-container">
          {data.map((item, index) => (
            <IndexFeaturesComponentItem
              key={"feature-items" + index}
              index={index + 1}
            >
              <div>
                <div className="index-items-feature-list-container">
                  <div className="index-items-feature-list-header-container">
                    <div>
                      <div className="index-items-feature-text-container">
                        <h3>{item.header}</h3>
                      </div>
                    </div>
                    <div>
                      <div className="index-items-feature-text-container">
                        {" "}
                        <p>
                          {
                            item.description
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="feature-list-bullet-point-container">
                    {
                      item.points.map((point_item, point_index) => (
                        <div className="feature-list-bullet-point">
                          <div>
                            <div className="feature-list-bullet-point-icon">
                              {" "}
                              <div>
                                <Staricon />
                              </div>{" "}
                            </div>
                          </div>
                          <div className="feature-list-bullet-point-text ">
                            <p> {point_item} </p>
                          </div>
                        </div>
                      ))
                    }

                  </div>
                </div>
                <div className="index-items-feature-image-container">
                  <IndexFeaturesComponentImageDiv></IndexFeaturesComponentImageDiv>
                </div>
              </div>
            </IndexFeaturesComponentItem>
          ))}
        </div>
      </div>
    </IndexFeaturesComponentMainDiv>
  );
};

const data = [
  {
    header: "Multi‑Model Connectivity",
    description: "Connect with Claude, Gemini, GPT and more—all from one unified extension.",
    points: [
      "Easy cross‑platform integration",
      "Flexible switching between models",
      "Unified access in one place"
    ]
  },
  {
    header: "Instant AI Collaboration",
    description: "Run tasks, query data, or generate content across multiple models instantly.",
    points: [
      "Real‑time responses",
      "Streamlined workflows",
      "Effortless productivity"
    ]
  },
  {
    header: "Smart Action Chaining",
    description: "Link outputs from one AI model to another for powerful multi‑step workflows.",
    points: [
      "Automated task chaining",
      "Context carried across models",
      "Scalable, adaptive workflows"
    ]
  }
];


export default IndexFeaturesComponent;
